var WaitListAppointmentsServicesModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    index: 1,
    serviceId: null,
    centralServiceId: null,
    serviceName: null,
    employeeId: null,
    photoId: null,
    employeeName: null,
    isFirstAvailable: false,
    minPrice: 0,
    maxPrice: 0,
    showPrice: true,
    minDuration: 0,
    maxDuration: 0,
    showDuration: true,
    clientId: -1,
    firstName: '',
    lastName: '',
    addons: []
  },

  computeds: {
    hasAddons: {
      deps:['addons'],
      get: function(addons) {
        return addons.length > 0;
      }
    },

    addonsString: {
      deps:['addons'],
      get: function(addons) {
        return _.pluck(addons, 'serviceName').join('; ');
      }
    },

    employeeNameString: {
      deps:['isFirstAvailable', 'employeeId', 'employeeName'],
      get: function(isFirstAvailable, employeeId, employeeName) {
        if (isFirstAvailable) {
          return 'First Available';
        } else {
          if (employeeId == null || employeeId < 0) {
            return '';
          } else {
            return employeeName;
          }
        }
      }
    },

    priceString: {
      deps:['minPrice', 'maxPrice'],
      get: function(minPrice, maxPrice) {
        return bookedby.helpers.priceRange([minPrice, maxPrice]);
      }
    },

    fullName: {
      deps:['firstName', 'lastName'],
      get: function(firstName, lastName) {
        return firstName + ' ' + lastName;
      }
    }
  },

  validation: { }
});

module.exports = WaitListAppointmentsServicesModel;